import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { Particles } from "components"
import { Content } from "./components"
import pdfFile from "../../assets/resume.pdf"
import { AiOutlineDownload } from "react-icons/ai"
import localization from "utils/localization"

function Resume() {
    return (
        <Container fluid className="resume-section">
            <Particles />
            <Container>
                <Row style={{ justifyContent: "center", position: "relative" }}>
                    <Button variant="primary" href={ pdfFile } target="_blank">
                        <AiOutlineDownload />
                        &nbsp;{ localization('download-resume') }
                    </Button>
                </Row>
                <Row className="resume">
                    <Col md={6} className="resume-left">
                        <h3 className="resume-title">{ localization('work') }</h3>
                        <Content
                            title="The Brooklyn Brothers"
                            date={ localization('work-tbb-date') }
                            content={[
                                localization('work-tbb-description'),
                            ]}
                        />
                        <Content
                            title="Sicoob Credisulca"
                            date={ localization('work-sicoob-date') }
                            content={[
                                localization('work-sicoob-description-3'),
                                localization('work-sicoob-description-2'),
                                localization('work-sicoob-description-1')
                            ]}
                        />
                        <h3 className="resume-title">{ localization('education') }</h3>
                        <Content
                            title={ localization('education-title')}
                            date="2017 - 2021"
                            content={[
                                localization('education-description-1'),
                                localization('education-description-2')
                            ]}
                        />
                    </Col>
                    <Col md={6} className="resume-right">
                        <h3 className="resume-title">{ localization('other-activities') }</h3>
                        <Content
                            title="MetalPass"
                            date={ localization('other-metalpass-date') }
                            content={[ localization('other-metalpass-description') ]}
                        />
                        <Content
                            title="OX3 Ozônio"
                            date={ localization('other-ox3-date') }
                            content={[ localization('other-ox3-description') ]}
                        />
                        <Content
                            title="Easy House SOS"
                            date={ localization('other-easy-house-date') }
                            content={[ localization('other-easy-house-description') ]}
                        />
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}

export default Resume